import { useUserContext } from '@ilteducation/ilt-auth';
import { useAggregateContexts, useSearchContexts } from '@ilteducation/content-search';
import { useMyOrganizations } from '@ilteducation/my-account';

const useLogout = () => {
  const userContextStore = useUserContext();
  const { clearSearch: clearBookSearch } = useSearchContexts('Book');
  const { commonLogout: userContextLogout } = userContextStore;
  const { clearAggr: clearVideoAggr } = useAggregateContexts('Video');
  const { reset: resetMyOrganizations } = useMyOrganizations();

  return async () => {
    clearBookSearch();
    clearVideoAggr();
    resetMyOrganizations();
    await userContextLogout();
  };
};

export default useLogout;
